<!-- 资料变更历史 -->
<template>
    <div class='page_content'>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
            <materialAlteration v-if="showStatus" ref="materialAlteration" @drawerCancel="drawerCancel" :actionData="actionData">
            </materialAlteration>
        </el-drawer>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" :buttonFlag="false"></v-button>
            <div class="page_content_top_line">
                <v-search v-if="formList.dataChangeHistory.length > 0" :flagList="['gchmState', 'gchmType']" :searchList="formList.dataChangeHistory" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch">
                    <template slot="searchInput" slot-scope="{formOneValue}">
                        <el-select v-if="formOneValue.entityField == 'gchmState'" v-model="getRequestData.gchmState" size="mini" clearable>
                            <el-option v-for="(values) in [{ key: 0, value: '初始' }, { key: -1, value: '审核退回' }]" :label="values.value" :key="values.value" :value="values.key"></el-option>
                        </el-select>
                        <el-radio-group v-if="formOneValue.entityField == 'gchmType'" v-model="getRequestData.gchmType" size="mini">
                            <el-radio-button label="">全部</el-radio-button>
                            <el-radio-button v-for="(values, keys) in $store.state.dataChangeTypeX" :label="values.id" :key="keys">{{ values.name }}</el-radio-button>
                        </el-radio-group>
                    </template>
                </v-search>
            </div>
        </div>
        <div class="page_content_center">
            <el-table @selection-change="handleSelectionChange" size="mini" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row>
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column align="center" prop="gchmId" label="编号" show-overflow-tooltip width="150">
                    <template slot-scope="scope">
                        <a @click="toDetail(scope.row.gchmId)">{{ scope.row.gchmId}}</a>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="depName" label="申请部门" show-overflow-tooltip min-width="100">
                </el-table-column>
                <el-table-column align="center" prop="opmName" label="申请人员" show-overflow-tooltip min-width="100">
                </el-table-column>
                <el-table-column align="center" prop="chanCode" label="业务编码" show-overflow-tooltip min-width="120"></el-table-column>
                <el-table-column align="center" prop="chanName" label="名称" show-overflow-tooltip min-width="160">
                </el-table-column>
                <el-table-column align="center" prop="gchmType" label="变更类别" show-overflow-tooltip min-width="100">
                    <template slot-scope="scope">
                        <div v-if="$store.state.dataChangeTypeX[scope.row.gchmType]">
                            {{ $store.state.dataChangeTypeX[scope.row.gchmType].name }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="applyReason" label="申请原因" show-overflow-tooltip min-width="120"></el-table-column>
                <el-table-column align="center" prop="remark" label="修改备注" show-overflow-tooltip min-width="120">
                </el-table-column>
                <el-table-column align="center" show-overflow-tooltip label="状态" prop="gchmState" width="100">
                    <template slot-scope="scope">
                        <el-tag size="mini">
                            {{$common.getIsGsp('[{"key":0,"value":"初始"},{"key":-1,"value":"审核退回"},{"key":1,"value":"提交审核"},{"key":2,"value":"审核通过"}]',scope.row.gchmState) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="fileNumber" label="档案编号" show-overflow-tooltip min-width="120"></el-table-column>
                <el-table-column align="center" show-overflow-tooltip label="变更时间" prop="createTime" min-width="120">
                    <template slot-scope="scope">
                        <span>
                            {{ $common.getLocalTime(scope.row['createTime']) }}
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel" :parentSearchData="parentSearchData" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import formList from './licenseChangeJson.js'
import SearchScheme from "../../../byComponents/SearchScheme.vue";
import materialAlteration from "./materialAlteration.vue";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: { SearchScheme, materialAlteration },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            getRequestData: {
                chanName: '',
                page: 1,
                rows: 30,
                start: '',
                end: '',
                gchmState: '',
                gchmType: "",
            },
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: []
            },

            buttonList: [],
            selectData: [],
            showStatus: false,
            actionData: {},
            formList: formList,
            DialogVisible: false,
            seId: "",
            seTitle: "",
            seWidth: "",
            parentSearchData: {},
            sField: "",
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        'getRequestData.gchmType': {
            handler: function (newValue, oldValue) {
                this.searchData()
            },
            deep: true,
        }
    },
    //方法集合
    methods: {
        handleSelectionChange(val) {
            this.selectData = val
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        // 检索Id, 索引(表格中), 标识ppamId
        openSearch({ sId, index, type, sField }) {
            this.DialogVisible = true;
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField
            this.parentSearchData[type] = this.getRequestData[type]
        },
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val)
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]
            })
        },
        // 子组件触发
        drawerCancel(commitData) {
            this.showStatus = false
            commitData && this.getDataList()
        },
        getPageInfo() {
            this.getDataList()
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页
                var isPenetrate = true;
                // 设置缓存 存入点击单号
                this.resetSetItem("penetrateOrderId", orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage(
                    {
                        //向窗口发送MessageEvent消息
                        cmd: "returnFormJson",
                        params: { isPenetrate }, //参数
                    },
                    "*"
                );
            }
        },
        lookDetail(data) {
            this.showStatus = true
            this.actionData = {
                cate: 2,
                formData: "",
                oldData: data,
                orderId: '',
                printSouce: '',
                printJurId: ''
            }
        },
        // 动作集合
        actionSet(actionData) {
            console.log(actionData.actionType);

            switch (actionData.actionType) {
                case 4:
                    this.actionData = {
                        cate: actionData.actionType,
                        formData: [],
                        oldData: "",
                        orderId: '',
                        printSouce: '',
                        printJurId: ''
                    }
                    this.showStatus = true
                    break;
                case 5:
                    this.actionData = {
                        cate: actionData.actionType,
                        formData: [],
                        oldData: "",
                        orderId: '',
                        printSouce: '',
                        printJurId: ''
                    }
                    this.showStatus = true
                    break;
                case 6:
                    this.actionData = {
                        cate: actionData.actionType,
                        formData: [],
                        oldData: "",
                        orderId: '',
                        printSouce: '',
                        printJurId: ''
                    }
                    this.showStatus = true
                    break;
                case 7:
                    this.actionData = {
                        cate: actionData.actionType,
                        formData: [],
                        oldData: "",
                        orderId: '',
                        printSouce: '',
                        printJurId: ''
                    }
                    this.showStatus = true
                    break;
                case 8:
                    this.actionData = {
                        cate: actionData.actionType,
                        formData: [],
                        oldData: "",
                        orderId: '',
                        printSouce: '',
                        printJurId: ''
                    }
                    this.showStatus = true
                    break;
                case 10:
                    this.actionData = {
                        cate: actionData.actionType,
                        formData: [],
                        oldData: "",
                        orderId: '',
                        printSouce: '',
                        printJurId: ''
                    }
                    this.showStatus = true
                    break;
                case 9:
                    this.actionData = {
                        cate: actionData.actionType,
                        formData: [],
                        oldData: "",
                        orderId: '',
                        printSouce: '',
                        printJurId: ''
                    }
                    this.showStatus = true
                    break;
                case 1:
                    this.updata()
                    break;
                case 2:
                    this.deleteClck()
                    break;
                case 3:
                    this.submitData()
                    break;
            }
        },
        // 提交审核
        async submitData() {
            if (this.returnData.list.length == 0) {
                return this.$message.error("暂无数据")
            }
            if (this.selectData.length == 0) {
                return this.$message.error("请先选择您要操作的数据")
            }
            var delData = {
                ids: this.selectData.map(item => item.gchmId),
            }
            let responseData = await this.$http.submitDataChange(delData)
            if (responseData.status == 200) {
                this.$message({
                    type: 'success',
                    message: '操作成功!'
                });
                this.getDataList()
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        //修改查询明细
        async updata() {
            if (this.returnData.list.length == 0) {
                return this.$message.error("暂无数据")
            }
            if (this.selectData.length != 1) {
                return this.$message.error("请先选择您要操作的一条数据")
            }
            let dataInfo = this.selectData[0]
            const res = await this.$http.gspChangequeryChangeInfoDetail({ ids: [dataInfo.gchmId] })
            if (res.status == 200) {
                var data = {}
                var data1 = JSON.parse(JSON.stringify(res.result))
                if (dataInfo.gchmType == 0) {
                    data = res.result.busgoodmastInfo == null ? {} : res.result.busgoodmastInfo
                    this.$set(data, 'newGoodLicenceAddList', data.newGoodLicenceAddList.length > 0 ? data.newGoodLicenceAddList : data.descibGoodLicenceAddList)

                } else if (dataInfo.gchmType == 1) {
                    data = res.result.suppliermasterInfo == null ? {} : res.result.suppliermasterInfo
                    this.$set(data, 'newLicencelinfos', data.newLicencelinfos.length > 0 ? data.newLicencelinfos : data.suplicencelinfos)
                } else if (dataInfo.gchmType == 2) {
                    data = res.result.descibCusmaster == null ? {} : JSON.parse(JSON.stringify(res.result.descibCusmaster))
                    this.$set(data, 'newLicencelinfos', data.cuslicencelinfos.length > 0 ? data.cuslicencelinfos : data.oldlicencelinfos)
                    this.$set(data, 'newDescibCusAddress', res.result.newDescibCusAddress.length > 0 ? res.result.newDescibCusAddress : res.result.oldDescibCusAddress)
                    this.$set(data, 'oldDescibCusAddress', res.result.oldDescibCusAddress.length > 0 ? res.result.oldDescibCusAddress : res.result.oldDescibCusAddress)
                }
                if (res.result.detailList) {
                    res.result.detailList.forEach(item => {
                        this.$set(data, item.entityField, item.newValue)
                    })
                }
                this.$set(data1, 'gchmId', dataInfo.gchmId)
                this.actionData = {
                    cate: '修改-1',
                    type: dataInfo.gchmType,// 0 商品 1供应商 2客户 3委托书
                    formData: [],
                    oldData: data,
                    oldData1: data1,
                    orderId: '',
                    printSouce: '',
                    printJurId: ''
                }
                this.showStatus = true
            } else {
                this.$message.error(res.message)
            }
        },
        async deleteClck() {
            if (this.returnData.list.length == 0) {
                return this.$message.error("暂无数据")
            }
            if (this.selectData.length != 1) {
                return this.$message.error("请先选择您要操作的一条数据")
            }
            let dataInfo = this.selectData[0]
            const res = await this.$http.gspChangedeleteChangeInfo({ ids: [dataInfo.gchmId] })
            if (res.status == 200) {
                this.$message.success(res.message)
                this.getDataList()
            } else {
                this.$message.error(res.message)
            }
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1
            this.getDataList()
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val
            this.getDataList()
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1
            this.getRequestData.rows = val
            this.getDataList()
        },


        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.gspChangequeryChangeInfo(this.getRequestData)
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list
                this.returnData.pages = responseData.result.pages
                this.returnData.total = responseData.result.total
                this.returnData.pageNum = responseData.result.pageNum
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        var objs = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
        for (const key in objs) {
            this.$set(this.getRequestData, key, objs[key])
        }
        this.getDataList()
        this.getButtonList()

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>